import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL, LabelL } from '@sorare/core/src/atoms/typography';
import { OnboardingButton } from '@sorare/core/src/components/onboarding/OnboardingButton';
import {
  FOOTBALL_ONBOARDING_CHOOSE_YOUR_LEVEL,
  FOOTBALL_ONBOARDING_TUTORIAL_PLAY,
} from '@sorare/core/src/constants/__generated__/routes';
import { glossary } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { MarketGuidanceLayout } from 'components/onboarding/MarketGuidanceLayout';
import { RecruitPlayersAnimation } from 'components/onboarding/RecruitPlayersAnimation';

const Root = styled(Vertical).attrs({ gap: 4 })`
  justify-content: space-between;
  flex: 1;
  width: 100%;

  @media ${tabletAndAbove} {
    width: auto;
  }
`;
const StyledOnboardingButton = styled(OnboardingButton)`
  position: sticky;
  bottom: var(--double-unit);
`;

const TutorialRecruitPage = () => {
  return (
    <MarketGuidanceLayout
      progress={10}
      center
      backUrl={FOOTBALL_ONBOARDING_CHOOSE_YOUR_LEVEL}
    >
      <Root center>
        <Vertical gap={1.5} center>
          <FormattedMessage
            id="TutorialRecruitPage.title"
            defaultMessage="<em>Scout</em><label>the players you love</label>"
            values={{
              em: chunks => <BrandL>{chunks}</BrandL>,
              label: chunks => <LabelL>{chunks}</LabelL>,
            }}
          />
        </Vertical>
        <RecruitPlayersAnimation />
        <StyledOnboardingButton
          size="large"
          color="secondary"
          to={FOOTBALL_ONBOARDING_TUTORIAL_PLAY}
          prefetch="render"
        >
          <FormattedMessage {...glossary.continue} />
        </StyledOnboardingButton>
      </Root>
    </MarketGuidanceLayout>
  );
};
export default TutorialRecruitPage;
